import { createAsyncThunk } from '@reduxjs/toolkit';
import AuthServices from './authService';
import { toast } from 'react-toastify';

export const loginUser = createAsyncThunk(
  'auth/loginUser',
  async (credentials, thunkAPI) => {
    try {
      const delivered = await AuthServices.Login(credentials);

      credentials.navigate('/admin_dashboard/home');

      return delivered;
    } catch (e) {
      toast(e.message);
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const GetSingleUser = createAsyncThunk(
  'auth/getSingleUser',
  async (_, thunkAPI) => {
    try {
      const delivered = await AuthServices.getSingleUser();
      return delivered;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);
